import { useState, useEffect } from "react";

const FnCreateContestsForm = ({ show, onClose, onSubmit, editData }) => {
  const [form, setForm] = useState({
    Id: "",
    contest_name: "",
    contest_size: "",
    entry_fee: "",
    winning_amount: "",
    min_contest_size: "",
  });

  // Populate form for edit mode
  useEffect(() => {
    if (show && editData) {
      setForm(editData);
    } else if (show) {
      setForm({
        Id: "",
        contest_name: "",
        contest_size: "",
        entry_fee: "",
        winning_amount: "",
        min_contest_size: "",
      });
    }
  }, [show, editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.contest_name || !form.entry_fee) {
      alert("Contest Name and Entry Fee are required");
      return;
    }

    onSubmit?.(form);
    onClose?.(); // This will close modal
  };

  if (!show) return null;

  return (
    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">
              {form.Id ? "Edit Contest" : "Create Contest"}
            </h6>
            <button
              className="close"
              type="button"
              onClick={onClose}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">

                <div className="col-md-6 mb-3">
                  <label>Contest Name *</label>
                  <input
                    type="text"
                    name="contest_name"
                    className="form-control"
                    value={form.contest_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>Contest Size</label>
                  <input
                    type="number"
                    name="contest_size"
                    className="form-control"
                    value={form.contest_size}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>Minimum Contest Size</label>
                  <input
                    type="number"
                    name="min_contest_size"
                    className="form-control"
                    value={form.min_contest_size}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>Entry Fee (₹) *</label>
                  <input
                    type="number"
                    name="entry_fee"
                    className="form-control"
                    value={form.entry_fee}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>Winning Amount (₹)</label>
                  <input
                    type="number"
                    name="winning_amount"
                    className="form-control"
                    value={form.winning_amount}
                    onChange={handleChange}
                  />
                </div>

              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={onClose}
                >
                  Cancel
                </button>

                <button type="submit" className="btn btn-primary" data-dismiss="modal">
                  {form.Id ? "Update Contest" : "Create Contest"}
                </button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FnCreateContestsForm;
